import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class RequiredForColumn extends Column {
    title = 'table.task-templates.createdFor';
    property = 'requiredForLabel';
    type: CellDisplay = CellDisplay.string;
    sortable = false;
}
